import React from "react";
import { Stack } from "react-bootstrap";

import "./AllowLocationManuallyOnAndroid.scss";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../utils/constants/generic-types";
import PrimaryActionButton from "../Buttons/PrimaryActionButton/PrimaryActionButton";
import { useTranslation } from "react-i18next";

export default function AllowLocationManuallyOnAndroid({
  isOpen,
  onClose,
}: GenericModalProps) {
  const { t } = useTranslation("common", { keyPrefix: "location" });
  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass="AllowLocationManuallyOnAndroid"
    >
      <Stack gap={4} className="pt-4">
        <Stack gap={2}>
          <h1 className="Grotesk Heading">{t("allow_location_services")}</h1>
          <ul className="ps-0 mb-0 InstructionSteps">
            <li className="Grotesk InstructionStep">
              <span className="StepCount">{t("step_1")}:</span>{" "}
              {t("open_chrome_and_tap_the_three_dot_menu")}.
            </li>
            <li className="Grotesk InstructionStep">
              <span className="StepCount">{t("step_2")}:</span>{" "}
              {t("go_to_settings_site_settings_permissions_location")}.
            </li>
          </ul>
          <p className="Grotesk FinalTip">
            {t("once_done_return_to_the_site_to_continue")}!
          </p>
        </Stack>

        <PrimaryActionButton text={t("okay")} onClick={onClose} />
      </Stack>
    </BottomDrawer>
  );
}
